module.exports = "/work-site/img/leave_car.0a0e07ca.png";